import i18n from "@/shared/i18n";
import InventoryModel from "@/modules/inventory/Inventory.model";
import NoteForm from "@/modules/customer/models/NoteForm.model";
import UserService from "@/modules/setup/user/UserService";
import CustomerService from "@/modules/customer/CustomerService";
import ReceiptService from "@/modules/receipt/ReceiptService";
import CategoryService from "@/modules/setup/category/CategoryService";
import {Formatter} from "@/core/services/formatter.service";
import SalesService from "../../../sales/SalesService";
import LotsService from "../../../lots/LotsService";
import {store} from '@/plugins/vuex'
import HelperService from "@/core/services/helper.service";

const reservationCollectedLabels = {
  'quantity': i18n.t('Quantity'),
  'lot': i18n.t('Lot'),
  'status': i18n.t('Status'),
  'auction': i18n.t('Sale'),
  'customer': i18n.t('Customer')
}


const inventoryActivityHelper = {
  actions: {
    'reserved': {
      message: i18n.t('Inventory item was reserved'),
    },
    'lotted': {
      message: i18n.t('Inventory item was lotted'),
    },
    'unlotted': {
      message: i18n.t('Inventory item was unlotted'),
    },
    'unreserved': {
      message: i18n.t('Inventory item was unreserved'),
    },
    'create.inventory_image': {
      message: i18n.t('Inventory Item Image was created'),
      attributeLabels: {name: i18n.t('Name')},
      excludeAttributes: ['inventory', 'data', 'image', 'filename', 'position', 'processing', 'generated_name']
    },
    'create.inventory': {
      message: i18n.t('Inventory item was created'),
      attributeLabels: new InventoryModel().attributeLabels,
      excludeAttributes: ['primary_image', 'active_lot', 'dynamic_fields']
    },
    'update.inventory': {
      message: i18n.t('Inventory item was updated'),
      attributeLabels: new InventoryModel().attributeLabels,
      excludeAttributes: ['primary_image', 'active_lot', 'dynamic_fields']
    },
    'create.inventory_note': {
      message: i18n.t('Note was created'),
      attributeLabels: new NoteForm().attributeLabels,
      excludeAttributes: ['inventory']
    },
    'update.inventory_note': {
      message: i18n.t('Note was updated'),
      attributeLabels: new NoteForm().attributeLabels,
      excludeAttributes: ['inventory']
    },
    'delete.inventory_note': {
      message: i18n.t('Note was deleted'),
    },
    'reservation.mark_collected': {
      message: i18n.t('Reservation was marked collected'),
      attributeLabels: reservationCollectedLabels,
    },
    'reservation.unmark_collected': {
      message: i18n.t('Reservation was unmarked collected'),
      attributeLabels: reservationCollectedLabels,
    },
    'manual_reservation.mark_collected': {
      message: i18n.t('Manual reservation was marked collected'),
      attributeLabels: reservationCollectedLabels,
    },
    'manual_reservation.unmark_collected': {
      message: i18n.t('Manual reservation was unmarked collected'),
      attributeLabels: reservationCollectedLabels,
    },
    'approved': {
      message: i18n.t('Temporary inventory item was approved'),
    },
  },
  async valueVisualizer(activity, attr, val) {
    let returnValue = val;
    if (activity.name === 'inventory') {
      if (attr === 'short_description') {
        returnValue = Formatter.getByMasterLanguage(val);
      } else if (attr === 'receive_date') {
        returnValue = this.$options.filters.toDate(val);
      } else if (attr === 'branch') {
        let branch = this.branches.rows.find(b => b.uuid === val);
        returnValue = branch ? branch.name : '';
      } else if (attr === 'department') {
        let department = this.departments.rows.find(d => d.uuid === val);
        returnValue = department ? Formatter.getByMasterLanguage(department.name) : '';
      } else if (attr === 'expert_user' || attr === 'rep_user') {
        let response = await UserService.getUsers({'uuid': val});
        returnValue = response.body.results && response.body.results.length > 0 ? response.body.results[0].display_name : '';
      } else if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      } else if (attr === 'receipt') {
        let response = await ReceiptService.getReceipt(val);
        returnValue = response.body.receipt_no;
      } else if (attr === 'category') {
        let response = await CategoryService.getCategory(val);
        returnValue = Formatter.getByMasterLanguage(response.body.name);
      } else if (attr === 'status') {
        returnValue = val.charAt(0).toUpperCase() + val.slice(1);
      } else if (attr === 'specialists') {
        if (val.length) {
          let response = await UserService.getUsers({uuids: val.join(',')});
          const specialists = [];
          if (response && response.body && response.body.results) {
            response.body.results.forEach(u => specialists.push(u.display_name));
          }
          returnValue = specialists.join('</br>');
        }
      } else if (attr === 'item_location') {
        const location = HelperService.searchNested(store.state.global.itemLocations, val, 'uuid', 'children')
        if (location) returnValue = location.name
      }
    }

    if (activity.name === 'finance') {
      if (attr === 'customer') {
        let response = await CustomerService.getCustomer(val);
        returnValue = response.body.display_name;
      }
      if (attr === 'auction') {
        let response = await SalesService.getSale(val);
        returnValue = response.body.sale_no;
      }
      if (attr === 'lot') {
        let response = await LotsService.getLot(val);
        returnValue = response.body.lot_no;
      }
    }
    return returnValue;
  }
}


export default inventoryActivityHelper;
